module.exports = __webpack_public_path__ + "img/right.1635f860.png";